import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { Broadcast } from "~types/broadcast.ts";
import type { FixtureResponse } from "~types/fixture.ts";

export const useUpsertBroadcast = (options: UseMutationOptions<FixtureResponse, unknown, Array<Broadcast>> = {}) => {
  const request = useApi();
  const queryClient = useQueryClient();

  const { sport, organizationId, fixtureId } = useParams();
  if (!sport || !organizationId || !fixtureId) {
    throw new Error("Missing required params");
  }

  return useMutation<FixtureResponse, unknown, Array<Broadcast>, unknown>({
    mutationFn: (body: Array<Broadcast>) =>
      request(`${sport}/o/${organizationId}/fixtures/${fixtureId}`, {
        method: "PUT",
        body: { broadcasts: body.map((item) => ({ ...item, id: undefined })) },
      }),
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["broadcast", sport, organizationId, fixtureId],
      });
    },
  });
};
